module.exports = __webpack_public_path__ + "media/msgPrompt.659e4ae5.mp3";